/**
 * Periodos del panel de superadmin. Fechas 'YYYY-MM-DD' en hora local (el superadmin
 * opera desde México, misma zona que BILLING_TIMEZONE del back). Cada periodo trae
 * también su "anterior" equivalente para la comparativa.
 */
const pad = (n) => String(n).padStart(2, '0');
const toYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const firstOfMonth = (y, m) => new Date(y, m, 1);
const lastOfMonth = (y, m) => new Date(y, m + 1, 0);

export const PERIODS = [
  { key: 'this_month', label: 'Este mes' },
  { key: 'last_month', label: 'Mes pasado' },
  { key: 'last_3_months', label: 'Últimos 3 meses' },
  { key: 'year', label: 'Este año' },
];

export function resolvePeriod(key, now = new Date()) {
  const y = now.getFullYear();
  const m = now.getMonth();
  switch (key) {
    case 'last_month': {
      const from = firstOfMonth(y, m - 1);
      const to = lastOfMonth(y, m - 1);
      return {
        from: toYmd(from), to: toYmd(to),
        prevFrom: toYmd(firstOfMonth(y, m - 2)), prevTo: toYmd(lastOfMonth(y, m - 2)),
        label: from.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' }),
        prevLabel: 'el mes anterior',
      };
    }
    case 'last_3_months': {
      const from = firstOfMonth(y, m - 2);
      return {
        from: toYmd(from), to: toYmd(now),
        prevFrom: toYmd(firstOfMonth(y, m - 5)), prevTo: toYmd(lastOfMonth(y, m - 3)),
        label: 'últimos 3 meses',
        prevLabel: 'los 3 meses anteriores',
      };
    }
    case 'year': {
      return {
        from: `${y}-01-01`, to: toYmd(now),
        prevFrom: `${y - 1}-01-01`, prevTo: `${y - 1}-${pad(m + 1)}-${pad(now.getDate())}`,
        label: `${y}`,
        prevLabel: `el mismo tramo de ${y - 1}`,
      };
    }
    case 'this_month':
    default: {
      const from = firstOfMonth(y, m);
      const prevFrom = firstOfMonth(y, m - 1);
      const prevSameDay = new Date(y, m - 1, Math.min(now.getDate(), lastOfMonth(y, m - 1).getDate()));
      return {
        from: toYmd(from), to: toYmd(now),
        // Mes en curso vs el mismo tramo del mes pasado (no el mes completo): comparar
        // 16 días contra 31 haría ver caída donde no la hay.
        prevFrom: toYmd(prevFrom), prevTo: toYmd(prevSameDay),
        label: now.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' }),
        prevLabel: 'el mismo tramo del mes pasado',
      };
    }
  }
}

export const MONTH_SHORT = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export const fmtInt = (n) => (Number(n) || 0).toLocaleString('es-MX');
export const fmtMoney = (n) => `$${(Number(n) || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 })}`;

/** "hace 3 días" / "hoy" / "—" a partir de 'YYYY-MM-DD'. */
export function relativeDay(ymd) {
  if (!ymd) return '—';
  const [yy, mm, dd] = ymd.split('-').map(Number);
  const then = new Date(yy, mm - 1, dd);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const days = Math.round((today - then) / 86400000);
  if (days <= 0) return 'hoy';
  if (days === 1) return 'ayer';
  return `hace ${days} días`;
}

/** Variación % entre dos valores; null si no hay base. */
export function pctChange(current, previous) {
  const c = Number(current) || 0;
  const p = Number(previous) || 0;
  if (!p) return c ? null : 0;
  return Math.round(((c - p) / p) * 100);
}

export const totalCreated = (c) =>
  (c?.appointmentsCreated?.bot || 0) + (c?.appointmentsCreated?.web || 0) + (c?.appointmentsCreated?.panel || 0);
